import { render, staticRenderFns } from "./modalDisponibilita.vue?vue&type=template&id=10566596"
import script from "./modalDisponibilita.vue?vue&type=script&lang=js"
export * from "./modalDisponibilita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports